var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIconMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "none",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.797 5.387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,89.315v-2.3a5.834,5.834,0,0,1,5.834-5.834L9.55,84.155l2.716-2.977A5.834,5.834,0,0,1,18.1,87.012v2.3",
    transform: "translate(-1 -69.965)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.837,5.211A4.21,4.21,0,1,1,38.627,1a4.21,4.21,0,0,1,4.21,4.21",
    transform: "translate(-30.077 -1.001)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.837,5.211A4.21,4.21,0,1,1,38.627,1,4.21,4.21,0,0,1,42.837,5.211Z",
    transform: "translate(-30.077 -1.001)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconMobile);
export default __webpack_public_path__ + "static/media/user-icon-mobile.3a1d50c5405767bd2b9886cc967805aa.svg";
export { ForwardRef as ReactComponent };